import { IonContent, IonLoading, IonPage } from '@ionic/react';
import React from 'react';

import { SelectBranch } from '@/components/clinicGroup';
import { Invalid, Loading, Logo, Padding } from '@/components/common';
import {
  ClinicGroupProvider,
  useClinicGroup
} from '@/contexts/ClinicGroupContext';

const Group: React.FC = () => {
  const { loading, clinicGroup } = useClinicGroup();

  return (
    <IonPage id="clinic-group-page">
      <IonContent>
        <Padding>
          <Logo />
          {clinicGroup ? <SelectBranch /> : loading ? <Loading /> : <Invalid />}
        </Padding>
      </IonContent>

      <IonLoading
        isOpen={!!clinicGroup && loading}
        message="Loading..."
        spinner="crescent"
      />
    </IonPage>
  );
};

const GroupWithProvider: React.FC = () => (
  <ClinicGroupProvider>
    <Group />
  </ClinicGroupProvider>
);

export default GroupWithProvider;
